import React from 'react';
import images from '../../../assets/images';
import { useTranslation } from 'react-i18next';

interface AccessDeniedProps {
  message: string;
}

const AccessDenied: React.FC<AccessDeniedProps> = ({ message }) => {
  const { t } = useTranslation();
  return (
    <div className="login-contain">
      <div className="text-center">
        <div className="title-outer">
          <h1 className="title">
            <span className="icon">
              <img src={images.emailSVG} alt={t<string>('navbar.title')} />
            </span>
          </h1>
        </div>
        <div className="alert alert-danger" role="alert" style={{ backgroundColor: 'white', border: 'none' }}>
          <h1>{t('federatedAccountMigration.message.accessDenied')}</h1>
          <p className="danger">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
